import { render, staticRenderFns } from "./banksetPopup.vue?vue&type=template&id=09c48620&scoped=true"
import script from "./banksetPopup.vue?vue&type=script&lang=js"
export * from "./banksetPopup.vue?vue&type=script&lang=js"
import style0 from "./banksetPopup.vue?vue&type=style&index=0&id=09c48620&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c48620",
  null
  
)

export default component.exports